import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Crown, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PremiumMethodNoticeProps {
  methodName: string;
}

const PremiumMethodNotice: React.FC<PremiumMethodNoticeProps> = ({ methodName }) => {
  const navigate = useNavigate();

  return (
    <Card className="w-full max-w-2xl mx-auto mt-8">
      <CardContent className="p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">
            Método Premium: {methodName}
          </h3>
          <p className="text-gray-600 text-lg">
            Este método está disponível apenas para assinantes
          </p>
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6 mb-6">
          <div className="flex items-center justify-center mb-3">
            <Crown className="w-6 h-6 text-yellow-500 mr-2" />
            <span className="text-lg font-semibold text-gray-800">
              Acesso Premium Necessário
            </span>
          </div>
          <p className="text-gray-700 mb-4">
            Para acessar todos os 8 métodos IA exclusivos, você precisa de um plano pago.
          </p>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>✨ Acesso a todos os métodos IA avançados</li>
            <li>🎯 Palpites mais precisos e estratégicos</li>
            <li>📊 Análises detalhadas dos padrões</li>
            <li>🚀 Ferramentas exclusivas para maximizar ganhos</li>
          </ul>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/plans')}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 text-lg"
          >
            Ver Planos e Assinar
          </Button>
          <Button 
            variant="outline"
            onClick={() => navigate('/gerar-jogos')}
            className="w-full"
          >
            Voltar para Gerar Jogos
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PremiumMethodNotice;